import React, { useEffect, useState } from "react";
import api from "../../../../../api";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const AboutSection = () => {
  const [showMoreDesktop, setShowMoreDesktop] = useState(false);
  const [showMoreMobile, setShowMoreMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [aboutSection, setAboutSection] = useState(null);

useEffect(() => {
  const fetchAbout = async () => {
    try {
      const response = await api.get("/api/sitepages/about-us/library");

      const about = response.data.groups?.[3]?.about_section || {};

      const contentArray = about.about_content
        ? Object.values(about.about_content)
        : [];

      const carouselArray = about.about_carousel
        ? about.about_carousel.map(img =>
            img.startsWith("/storage")
              ? `${process.env.REACT_APP_API_URL}/public${img}`
              : img
          )
        : [];

      setAboutSection({
        ...about,
        about_content: contentArray,
        about_carousel: carouselArray
      });

    } catch (err) {
      console.error("About API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchAbout();
}, []);


  if (loading || !aboutSection) return null;

  return (
    <section className="about-section" id="about">

      {/* DESKTOP VIEW */}
      <div className="container d-md-block d-none">
        <div className="sec-title text-center">
          <h2>{aboutSection.title}</h2>
        </div>

        <div className="row align-items-center">

          {/* LEFT TEXT */}
          <div className="col-md-6 col-12">
            <div className="text-para">

              {/* Main Content - Supports HTML */}
              {aboutSection.about_content.map((html, i) => (
                <p key={i} dangerouslySetInnerHTML={{ __html: html }} />
              ))}

              {/* Read More Content (Desktop) */}
              {showMoreDesktop && (
                <div>
                  {Array.isArray(aboutSection.read_more_btn_content)
                    ? aboutSection.read_more_btn_content.map((html, i) => (
                        <p key={i} dangerouslySetInnerHTML={{ __html: html }} />
                      ))
                    : aboutSection.read_more_btn_content && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: aboutSection.read_more_btn_content
                          }}
                        />
                      )}
                </div>
              )}

              {/* Button */}
              <button
                onClick={() => setShowMoreDesktop(!showMoreDesktop)}
                className="readmoreall mb-3"
              >
                {showMoreDesktop
                  ? aboutSection.read_less_btn
                  : aboutSection.read_more_btn}
              </button>
            </div>
          </div>

          {/* RIGHT SLIDER */}
          <div className="col-md-6 col-12">
            <Swiper
              modules={[Pagination, Autoplay]}
              slidesPerView={1}
              autoplay={true}
              pagination={false}
              className="panorama-slider"
            >
              {aboutSection.about_carousel.map((src, i) => (
                <SwiperSlide key={i}>
                  <img src={src} className="img-fluid"  style={{borderRadius:'10PX'}} alt={`Slide ${i + 1}`} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>

      {/* MOBILE VIEW */}
      <div className="container d-md-none d-block">

        <div className="sec-title text-center">
          <h2>{aboutSection.title}</h2>
        </div>

        <div className="row">
           <div className="col-12">
            <Swiper
              modules={[Pagination, Autoplay]}
              slidesPerView={1}
              autoplay={true}
              pagination={false}
              className="panorama-slider mb-3"
            >
              {aboutSection.about_carousel.map((src, i) => (
                <SwiperSlide key={i}>
                  <img src={src} className="img-fluid" style={{borderRadius:'10PX'}} alt={`Slide ${i + 1}`} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="col-12">
            <div className="text-para">

              {/* First Paragraph Only */}
              {aboutSection.about_content.length > 0 && (
                <p dangerouslySetInnerHTML={{ __html: aboutSection.about_content[0] }} />
              )}

              {/* More Content */}
              {showMoreMobile && (
                <>
                  {aboutSection.about_content.slice(1).map((html, i) => (
                    <p key={i} dangerouslySetInnerHTML={{ __html: html }} />
                  ))}

                  {/* Read More HTML */}
                  {Array.isArray(aboutSection.read_more_btn_content)
                    ? aboutSection.read_more_btn_content.map((html, i) => (
                        <p key={i} dangerouslySetInnerHTML={{ __html: html }} />
                      ))
                    : aboutSection.read_more_btn_content && (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: aboutSection.read_more_btn_content
                          }}
                        />
                      )}
                </>
              )}

              {/* Button */}
              <button
                onClick={() => setShowMoreMobile(!showMoreMobile)}
                className="readmoreall mb-3"
              >
                {showMoreMobile
                  ? aboutSection.read_less_btn
                  : aboutSection.read_more_btn}
              </button>
            </div>
          </div>

          {/* Mobile Carousel */}
         
        </div>
      </div>

    </section>
  );
};

export default AboutSection;
